import React from "react";
import agent from "../agent";
import { connect } from "react-redux";

import { AsideDefault } from "../widgets/components/aside/AsideDefault";
import { Footer } from "../widgets/components/Footer";
import { HeaderWrapper } from "../widgets/components/header/HeaderWrapper";
import { Toolbar } from "../widgets/components/toolbar/Toolbar";
import { ScrollTop } from "../widgets/components/ScrollTop";
import { Content } from "../widgets/components/Content";

import { ListLoading } from "../widgets/helpers/ListLoading";
import { ListPagination } from "../widgets/helpers/ListPagination";

//import {prepareRow} from '../utils/TableHelpers'

import { ModalUsers } from "../widgets/components/ModalUsers";

import clsx from "clsx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";

import {
  START_LOADING,
  STOP_LOADING,
  LOAD_USERS,
  LOAD_USER,
  NEW_USER,
  SAVE_USER,
  RESET_USER,
  ACTIVATE_USER,
  UPDATE_HEADERS,
  RESET_HEADERS,
  baseUrl,
} from "../constants/actionTypes";

const mapStateToProps = (state) => ({
  currentUser: state.common.currentUser,
  ...state.users,
});

const mapDispatchToProps = (dispatch) => ({
  loadUsers: (page, limit, search, sort) =>
    dispatch({
      type: LOAD_USERS,
      payload: agent.Admin.loadUsers(page, limit, search, sort),
    }),
  loadUser: (id) =>
    dispatch({ type: LOAD_USER, payload: agent.Admin.loadUser(id) }),
  newUser: () => dispatch({ type: NEW_USER }),
  resetUser: () => dispatch({ type: RESET_USER }),
  activateUser: (id) =>
    dispatch({ type: ACTIVATE_USER, payload: agent.Admin.activateUser(id) }),
  startLoading: () => dispatch({ type: START_LOADING }),
  stopLoading: () => dispatch({ type: STOP_LOADING }),
  setHeading: (column) => dispatch({ type: UPDATE_HEADERS, payload: column }),
  resetHeading: () => dispatch({ type: RESET_HEADERS }),
});

const defaultSwalProps = {
  icon: "info",
  buttonsStyling: false,
  padding: "0 0 2.0em",
  confirmButtonText: "Yes, Delete",
  customClass: {
    confirmButton: "btn btn-lg btn-info mx-2",
    cancelButton:
      "btn btn-lg btn-light mx-2 btn-active-icon-dark btn-active-text-dark",
  },
  showCancelButton: true,
  cancelButtonText: "Wait! Cancel",
};

class AdminUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInputValue: "",
      modalShow: false,
      bulkActionsVisible: false,
      bulkChecks: [],
    };
    this.timer = null;
  }

  componentDidMount() {
    this.props.loadUsers(
      this.props.currentPage,
      this.props.currentLimit,
      this.props.currentSearch
    );
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleActivate = this.handleActivate.bind(this);
    //window.addEventListener('resize', this.updateWindowDimensions);
    //console.log('componentDidMount',this.props);
  }

  componentWillUnmount() {}

  componentDidUpdate(prevProps) {}

  clickSearch = (searchText) => {
    this.setState({ searchInputValue: searchText });
    if (searchText.length < 2) {
      return;
    }
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.props.startLoading();
      this.props.loadUsers(
        this.props.currentPage,
        this.props.currentLimit,
        searchText,
        this.props.sort
      );
      this.setState({ bulkActionsVisible: false, bulkChecks: [] });
    }, 750);
  };

  resetSearch = () => {
    this.props.startLoading();
    this.props.resetHeading();
    this.props.loadUsers(1, 20, "", {});
    this.setState({
      searchInputValue: "",
      bulkActionsVisible: false,
      bulkChecks: [],
    });
  };

  sortHeading = (column) => {
    //console.log(column);
    this.props.setHeading(column);
    let dir = "asc"; //console.log(object);
    if (column.active) {
      if (column.dir === "asc") {
        dir = "desc";
      } else {
        dir = "asc";
      }
    } else {
      dir = "asc";
    }
    this.props.loadUsers(
      this.props.currentPage,
      this.props.currentLimit,
      this.props.currentSearch,
      { ...column, active: true, dir: dir }
    );
  };

  editRow = (userId) => {
    this.props.startLoading();
    if (userId > 0) {
      this.props.loadUser(userId);
    } else {
      this.props.newUser();
    }
    this.setState({ modalShow: true });
  };

  bulkImport = () => {
    this.setState({ importShow: !this.state.importShow });
  };

  // Diagnostics method for troubleshooting file upload issues
  async checkUploadDiagnostics() {
    this.props.startLoading();
    try {
      const response = await agent.Diagnostics.checkFilePermissions();
      if (response?.success === true) {
        const diag = response.diagnostics;
        let message = "<h4>File Upload Diagnostics:</h4><ul style='text-align: left; font-size: 14px;'>";
        message += `<li><strong>Storage Path:</strong> ${diag.storage_path}</li>`;
        message += `<li><strong>Directory Exists:</strong> ${diag.storage_exists ? 'Yes' : 'No'}</li>`;
        message += `<li><strong>Directory Writable:</strong> ${diag.storage_writable ? 'Yes' : 'No'}</li>`;
        message += `<li><strong>Can Create Files:</strong> ${diag.can_create_file ? 'Yes' : 'No'}</li>`;
        message += `<li><strong>Upload Max Size:</strong> ${diag.upload_max_filesize}</li>`;
        message += `<li><strong>Post Max Size:</strong> ${diag.post_max_size}</li>`;
        message += `<li><strong>Memory Limit:</strong> ${diag.memory_limit || 'Not available'}</li>`;
        message += `<li><strong>Max Execution Time:</strong> ${diag.max_execution_time || 'Not available'}s</li>`;
        message += `<li><strong>File Uploads Enabled:</strong> ${diag.file_uploads_enabled}</li>`;
        message += `<li><strong>Behind Nginx:</strong> ${diag.behind_nginx ? 'Yes' : 'No'}</li>`;
        message += `<li><strong>Current User:</strong> ${diag.current_user}</li>`;
        message += `<li><strong>Free Disk Space:</strong> ${diag.disk_free_space ? Math.round(diag.disk_free_space / 1024 / 1024) + ' MB' : 'Unknown'}</li>`;
        
        if (diag.nginx_temp_dirs) {
          message += "<li><strong>Nginx Temp Directories:</strong><ul>";
          for (const [dir, info] of Object.entries(diag.nginx_temp_dirs)) {
            if (info.exists) {
              message += `<li>${dir}: Writable: ${info.writable ? 'Yes' : 'No'}</li>`;
            } else {
              message += `<li>${dir}: Does not exist</li>`;
            }
          }
          message += "</ul></li>";
        }
        
        if (diag.test_file_error) {
          message += `<li style='color: red;'><strong>File Creation Error:</strong> ${diag.test_file_error}</li>`;
        }
        message += "</ul>";
        
        Swal.fire({
          ...defaultSwalProps,
          html: message,
          icon: diag.storage_writable && diag.can_create_file ? "info" : "warning",
          confirmButtonText: "OK",
          showCancelButton: false,
          customClass: { confirmButton: "btn btn-lg btn-primary mx-2" },
        });
      } else {
        throw new Error("Diagnostics failed");
      }
    } catch (error) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>Diagnostics failed: " + error.message + "</h3>",
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
      });
    }
    this.props.stopLoading();
  }

  async bulkImportProcess() {
    if (!this.state.fileupload) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>No upload file provided, please try again.</h3>",
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
      });
    } else {
      this.props.startLoading();
      const response = await agent.Admin.importUsers(this.state.fileupload);
      if (response?.success === true) {
        Swal.fire({
          ...defaultSwalProps,
          html: "<h3 className='fw-bolder text-dark display-6'>Users have been successfully imported.</h3>",
          icon: "success",
          confirmButtonText: "OK",
          showCancelButton: false,
          customClass: { confirmButton: "btn btn-lg btn-success mx-2" },
        });
        this.props.loadUsers(
          this.props.currentPage,
          this.props.currentLimit,
          this.props.currentSearch,
          this.props.sort
        );
        this.setState({ bulkActionsVisible: false, bulkChecks: [] });
      } else {
        let message = response?.message ? response.message : " No connection.";
        Swal.fire({
          ...defaultSwalProps,
          html:
            "<h3 className='fw-bolder text-dark display-6'>Upload failed, error: " +
            message +
            "</h3>",
          icon: "error",
          confirmButtonText: "OK",
          showCancelButton: false,
          customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
        });
        this.props.stopLoading();
      }
    }
    this.setState({ importShow: false });
  }

  deleteRow(id) {
    Swal.fire({
      ...defaultSwalProps,
      html:
        "<h3 className='fw-bolder text-dark display-6'>Delete User ID: " +
        id +
        "</h3><div className='text-muted fw-bold fs-3'>Are you sure you want to delete this user?</div>",
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.startLoading();
        this.processDeleteRow(id);
      }
    });
  }

  async processDeleteRow(id) {
    const response = await agent.Admin.deleteUser(id);
    if (response?.success === true) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>User has been deleted.</h3>",
        icon: "success",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-success mx-2" },
      });
      this.props.loadUsers(
        this.props.currentPage,
        this.props.currentLimit,
        this.props.currentSearch,
        this.props.sort
      );
      this.setState({ bulkActionsVisible: false, bulkChecks: [] });
    } else {
      let message = response?.message
        ? response.message
        : "Connection failed, please try again.";
      Swal.fire({
        ...defaultSwalProps,
        html:
          "<h3 className='fw-bolder text-dark display-6'>" + message + "</h3>",
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
      });
      this.props.stopLoading();
    }
  }

  deleteUsers(ids) {
    if (ids.length) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>Delete Users</h3><div className='text-muted fw-bold fs-3'>Are you sure you want to delete the selected users?</div>",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.startLoading();
          this.processDeleteUsers(ids);
        }
      });
    }
  }

  async processDeleteUsers(ids) {
    const response = await agent.Admin.deleteUsers(ids);
    if (response?.success === true) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>Users have been deleted.</h3>",
        icon: "success",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-success mx-2" },
      });
      this.props.loadUsers(
        this.props.currentPage,
        this.props.currentLimit,
        this.props.currentSearch,
        this.props.sort
      );
      this.setState({ bulkActionsVisible: false, bulkChecks: [] });
    } else {
      let message = response?.message
        ? response.message
        : "Connection failed, please try again.";
      Swal.fire({
        ...defaultSwalProps,
        html:
          "<h3 className='fw-bolder text-dark display-6'>" + message + "</h3>",
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
      });
      this.props.stopLoading();
    }
  }

  deleteAll() {
    Swal.fire({
      ...defaultSwalProps,
      html: "<h3 className='fw-bolder text-dark display-6'>Delete All Non-admin Users</h3><div className='text-muted fw-bold fs-3'>Are you sure you want to purge all users from the database? This cannot be reversed. This will only affect non-admin users.</div>",
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.startLoading();
        this.processDeleteAll();
      }
    });
  }

  async processDeleteAll() {
    const response = await agent.Admin.purgeUsers();
    if (response?.success === true) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>All users have been purged/deleted.</h3>",
        icon: "success",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-success mx-2" },
      });
      this.props.loadUsers(
        this.props.currentPage,
        this.props.currentLimit,
        this.props.currentSearch,
        this.props.sort
      );
      this.setState({ bulkActionsVisible: false, bulkChecks: [] });
    } else {
      let message = response?.message
        ? response.message
        : "Connection failed, please try again.";
      Swal.fire({
        ...defaultSwalProps,
        html:
          "<h3 className='fw-bolder text-dark display-6'>" + message + "</h3>",
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
      });
      this.props.stopLoading();
    }
  }

  async exportAllUsers() {
    this.props.startLoading();
    try {
      const response = await agent.Admin.exportUsers();
      if (response && response.status === 200) {
        // Create a blob from the response
        const blob = new Blob([response.body], { type: "text/csv" });

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger download
        const link = document.createElement("a");
        link.href = url;
        link.download = `${new Date().toISOString().split("T")[0]}_users.csv`;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        Swal.fire({
          ...defaultSwalProps,
          html: "<h3 className='fw-bolder text-dark display-6'>Users have been exported successfully.</h3>",
          icon: "success",
          confirmButtonText: "OK",
          showCancelButton: false,
          customClass: { confirmButton: "btn btn-lg btn-success mx-2" },
        });
      } else {
        throw new Error("Export failed");
      }
    } catch (error) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>Export failed, please try again.</h3>",
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
      });
    }
    this.props.stopLoading();
  }

  async handleSubmit(submitData) {
    this.props.startLoading();
    let that = this;
    let response = null;
    if (submitData.id > 0) {
      response = await agent.Admin.updateUser(submitData);
    } else {
      response = await agent.Admin.newUser(submitData);
    }
    if (response?.success === true) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>User has been saved.</h3>",
        icon: "success",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-success mx-2" },
      });
      that.props.loadUsers(
        that.props.currentPage,
        that.props.currentLimit,
        that.props.currentSearch,
        this.props.sort
      );
      that.setState({
        modalShow: false,
        bulkActionsVisible: false,
        bulkChecks: [],
      });
      that.props.resetUser();
    } else {
      let message = response?.message
        ? response.message
        : "Connection failed, please try again.";
      Swal.fire({
        ...defaultSwalProps,
        html:
          "<h3 className='fw-bolder text-dark display-6'>" + message + "</h3>",
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
      });
      that.props.stopLoading();
    }
  }

  async handleActivate(userId) {
    this.props.startLoading();
    let that = this;
    const response = await agent.Admin.activateUser(userId);
    if (response?.success === true) {
      Swal.fire({
        ...defaultSwalProps,
        html: "<h3 className='fw-bolder text-dark display-6'>User has been activated.</h3>",
        icon: "success",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-success mx-2" },
      });
      that.props.loadUsers(
        that.props.currentPage,
        that.props.currentLimit,
        that.props.currentSearch,
        this.props.sort
      );
      that.setState({
        modalShow: false,
        bulkActionsVisible: false,
        bulkChecks: [],
      });
      that.props.resetUser();
    } else {
      let message = response?.message
        ? response.message
        : "Connection failed, please try again.";
      Swal.fire({
        ...defaultSwalProps,
        html:
          "<h3 className='fw-bolder text-dark display-6'>" + message + "</h3>",
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        customClass: { confirmButton: "btn btn-lg btn-danger mx-2" },
      });
      that.props.stopLoading();
    }
  }

  handleModalClose = () => {
    this.props.resetUser();
    this.setState({ modalShow: false });
  };

  clickPagination = (pageNumber) => {
    this.props.startLoading();
    this.props.loadUsers(
      pageNumber,
      this.props.currentLimit,
      this.props.currentSearch,
      this.props.sort
    );
    this.setState({ bulkActionsVisible: false, bulkChecks: [] });
  };

  clickLimit = (limitNumber) => {
    this.props.startLoading();
    this.props.loadUsers(
      this.props.currentPage,
      limitNumber,
      this.props.currentSearch,
      this.props.sort
    );
    this.setState({ bulkActionsVisible: false, bulkChecks: [] });
  };

  toggleSelectAll = (e) => {
    let newBulkChecks = [];
    Array.from(
      document.querySelectorAll(
        ".table-responsive input[type=checkbox].rowSelector"
      )
    ).forEach((checkbox) => {
      document.getElementById(checkbox.id).checked = e.target.checked;
      if (e.target.checked) {
        newBulkChecks.push(document.getElementById(checkbox.id).value);
      }
    });
    this.setState({
      bulkActionsVisible: e.target.checked,
      bulkChecks: newBulkChecks,
    });
  };

  toggleSelect = (e) => {
    let currentBulkChecks = this.state.bulkChecks;
    if (e.target.checked) {
      currentBulkChecks.push(e.target.value);
    } else {
      currentBulkChecks = currentBulkChecks.filter(
        (item) => item !== e.target.value
      );
      document.getElementById("check-all").checked = false;
    }
    let currentBulkActionsVisible = currentBulkChecks.length > 0 ? true : false;
    this.setState({
      bulkActionsVisible: currentBulkActionsVisible,
      bulkChecks: currentBulkChecks,
    });
  };

  render() {
    return (
      <>
        <div className="d-flex flex-column flex-root">
          <div className="page d-flex flex-row flex-column-fluid">
            <AsideDefault />
            <div
              className="wrapper d-flex flex-column flex-row-fluid"
              id="kt_wrapper"
            >
              <HeaderWrapper
                title="User Management"
                currentUser={this.props.currentUser}
              />
              <Toolbar />
              <div
                id="kt_content"
                className="content d-flex flex-column flex-column-fluid"
              >
                <Content>
                  <div
                    className="subheader pb-2 pb-lg-4 subheader-transparent"
                    id="kt_subheader"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                      <div className="d-flex align-items-center flex-wrap mr-2">
                        <h5 className="text-dark font-weight-bold mt-2 mb-2">
                          Search:
                        </h5>
                        <div className="d-flex align-items-center">
                          <div className="ml-3">
                            <div
                              className="input-group input-group-md"
                              style={{ minWidth: "280px" }}
                            >
                              <input
                                type="text"
                                value={this.state.searchInputValue}
                                className="form-control"
                                placeholder="Enter email or username..."
                                onChange={(e) =>
                                  this.clickSearch(e.target.value)
                                }
                              />
                              {this.props.currentSearch !== "" ? (
                                <div className="input-group-append">
                                  <a
                                    className="btn btn-danger btn-icon"
                                    onClick={() => this.resetSearch()}
                                  >
                                    <i className="bi bi-x-circle-fill"></i>
                                  </a>
                                </div>
                              ) : (
                                <div className="input-group-append">
                                  <a
                                    className="btn btn-primary btn-icon"
                                    onClick={(e) =>
                                      this.clickSearch(
                                        this.state.searchInputValue
                                      )
                                    }
                                  >
                                    <i className="bi bi-search"></i>
                                  </a>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-5 bg-gray-200"></div>
                        <div className="d-flex align-items-center">
                          {this.props.currentSearch !== "" ? (
                            <span
                              className="text-dark-50 font-weight-bold"
                              id="kt_subheader_total"
                            >
                              {this.props.pagination.total} results for "
                              {this.props.currentSearch}"...
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <a className="btn btn-bg-white btn-text-muted btn-active-info btn-sm px-4 mx-2">
                          <i className="bi bi-filter mr-2" />
                          Confirmed
                        </a>
                        <a className="btn btn-bg-white btn-text-muted btn-active-info btn-sm px-4 mx-2">
                          <i className="bi bi-filter mr-2" />
                          Role
                        </a>
                        <a className="btn btn-bg-white btn-text-muted btn-active-info btn-sm px-4 mx-2">
                          <i className="bi bi-calendar mr-2" />
                          Created After
                        </a>
                        <a className="btn btn-bg-white btn-text-muted btn-active-info btn-sm px-4 mx-2 filter">
                          <i className="bi bi-calendar mr-2" />
                          Created Before
                          <div
                            className={clsx(
                              "card filterDrop text-start p-4 w-225px",
                              { show: false }
                            )}
                          >
                            <a className="py-2 d-block" href="#">
                              Admin
                            </a>
                            <a className="py-2 d-block" href="#">
                              User
                            </a>
                          </div>
                        </a>
                      </div>
                      {this.props.currentSearch !== "" ||
                      this.props.pagination.per_page !== 20 ||
                      this.props.pagination.current_page !== 1 ? (
                        <div className="d-flex align-items-center">
                          <a
                            className="btn btn-white btn-sm px-4 font-size-base ml-2"
                            onClick={() => this.resetSearch()}
                          >
                            <i className="bi bi-x-circle-fill"></i> Reset View
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="d-flex flex-column">
                    <div className="card card-custom">
                      <div className="card-header flex-wrap border-0 pt-6 pb-0">
                        <div className="card-title">
                          <h3 className="card-label">
                            Users
                            <span className="d-block text-muted pt-2 font-size-sm">
                              Manage user accounts.
                            </span>
                          </h3>
                        </div>
                        <div className="card-toolbar mw-500px d-flex justify-content-end">
                          <a
                            onClick={() => this.editRow(0)}
                            className="btn btn-sm btn-primary"
                          >
                            Add New User
                          </a>
                          <a
                            onClick={() => this.bulkImport()}
                            className="btn btn-sm btn-secondary mx-2"
                          >
                            Import Users
                          </a>
                          <a
                            onClick={() => this.exportAllUsers()}
                            className="btn btn-sm btn-secondary mx-2"
                          >
                            Export Users
                          </a>
                          <a
                            onClick={() => this.deleteAll()}
                            className="btn btn-sm btn-outline btn-outline-danger"
                          >
                            Purge All Users
                          </a>
                          {this.state.importShow ? (
                            <div className="card card-dashed d-flex flex-row shadow-sm w-400px mt-2">
                              <div className="py-3 pr-1 pl-3">
                                <input
                                  type="file"
                                  name="fileupload"
                                  className={clsx(
                                    "form-control form-control-lg form-control-solid",
                                    { ["is-invalid"]: false }
                                  )}
                                  onChange={(e) =>
                                    this.setState({
                                      fileupload: e.target.files[0],
                                    })
                                  }
                                />
                              </div>
                              <div className="py-3 pl-1 pr-3">
                                <a
                                  className="btn btn-primary"
                                  onClick={() => this.bulkImportProcess()}
                                >
                                  Upload
                                </a>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            id="kt_table_users"
                            className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
                          >
                            <thead>
                              <tr className="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
                                <th>
                                  <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 200, hide: 400 }}
                                    overlay={
                                      <Tooltip>Toggle Select All</Tooltip>
                                    }
                                  >
                                    <div className="form-check form-check-custom form-check-sm">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="all"
                                        id="check-all"
                                        onClick={(e) => this.toggleSelectAll(e)}
                                      />
                                    </div>
                                  </OverlayTrigger>
                                </th>
                                {this.props.headers.map((column, index) => {
                                  if (column.sort) {
                                    return (
                                      <th
                                        key={index}
                                        onClick={() => this.sortHeading(column)}
                                      >
                                        <OverlayTrigger
                                          placement="right"
                                          delay={{ show: 200, hide: 400 }}
                                          overlay={
                                            <Tooltip>
                                              Sort by {column.label}
                                            </Tooltip>
                                          }
                                        >
                                          <span
                                            className="d-flex text-info"
                                            style={{ cursor: "pointer" }}
                                          >
                                            {column.label}
                                            <i
                                              className={clsx(
                                                "bi text-info ml-2",
                                                {
                                                  ["bi-sort-down-alt"]:
                                                    column.active &&
                                                    column.dir === "asc",
                                                  ["bi-sort-up"]:
                                                    column.active &&
                                                    column.dir === "desc",
                                                }
                                              )}
                                            />
                                          </span>
                                        </OverlayTrigger>
                                      </th>
                                    );
                                  } else {
                                    return (
                                      <th key={index}>
                                        <span>{column.label}</span>
                                      </th>
                                    );
                                  }
                                })}
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-bold">
                              {this.props.users.length > 0 ? (
                                this.props.users.map((row) => {
                                  //row = prepareRow(row,['edit','delete']);
                                  return (
                                    <tr key={row.id}>
                                      <td>
                                        <div className="form-check form-check-custom form-check-sm">
                                          <input
                                            className="form-check-input rowSelector"
                                            id={"check-" + row.id}
                                            type="checkbox"
                                            value={row.id}
                                            onClick={(e) =>
                                              this.toggleSelect(e)
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>{row.email}</td>
                                      <td>{row.firstname}</td>
                                      <td>{row.lastname}</td>
                                      <td>
                                        {row.active === 1 ? (
                                          <span className="badge badge-light-success fs-8 px-2 py-1">
                                            Yes
                                          </span>
                                        ) : (
                                          <span className="badge badge-light fs-8 px-2 py-1">
                                            No
                                          </span>
                                        )}
                                      </td>
                                      <td>
                                        <span
                                          className={clsx(
                                            "badge badge-light fs-8 px-2 py-1",
                                            {
                                              ["badge-light-secondary"]:
                                                row.role === "admin",
                                            }
                                          )}
                                        >
                                          {row.role[0].toUpperCase() +
                                            row.role.substring(1)}
                                        </span>
                                      </td>
                                      <td className="d-flex align-items-center justify-content-end">
                                        <a
                                          onClick={() => this.editRow(row.id)}
                                          className="btn btn-icon btn-sm btn-primary mr-2"
                                        >
                                          <i className="bi bi-pencil-fill"></i>
                                        </a>
                                        <a
                                          onClick={() => this.deleteRow(row.id)}
                                          className="btn btn-icon btn-sm btn-outline btn-outline-danger text-hover-white mr-2"
                                        >
                                          <i className="bi bi-trash-fill text-danger"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={7}>
                                    <div className="d-flex text-center w-100 align-content-center justify-content-center">
                                      No results found.
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <ListPagination
                          pagination={this.props.pagination}
                          results={this.props.users}
                          clickPagination={this.clickPagination}
                          clickLimit={this.clickLimit}
                          isLoading={this.props.isLoading}
                        />
                        {this.props.isLoading && <ListLoading />}
                        {this.state.bulkActionsVisible ? (
                          <div className="bulkActions card card-flush card-dashed bg-white shadow-sm mb-0">
                            <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                              <div className="card-body py-3 px-3 text-center">
                                <a
                                  onClick={() =>
                                    this.deleteUsers(this.state.bulkChecks)
                                  }
                                  className="btn btn-sm btn-primary btn-danger btn-text-white mx-2"
                                >
                                  Delete Selected{" "}
                                  <i className="bi bi-trash-fill" />
                                </a>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  
                  {/* Diagnostic Tools - Bottom of Page */}
                  <div className="row mt-5">
                    <div className="col-12">
                      <div className="card card-flush">
                        <div className="card-body text-center py-3">
                          <small className="text-muted me-3">Diagnostic Tools:</small>
                          <a
                            onClick={() => this.checkUploadDiagnostics()}
                            className="btn btn-sm btn-light btn-outline-secondary"
                            title="Check file upload permissions and server configuration"
                          >
                            <i className="fas fa-tools me-1"></i>
                            Check Upload Diagnostics
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </Content>
              </div>
              <Footer />
            </div>
          </div>
        </div>
        <ModalUsers
          show={this.state.modalShow}
          handleSubmit={this.handleSubmit}
          handleActivate={this.handleActivate}
          handleClose={this.handleModalClose}
          userData={this.props.userData}
          action={this.props.action}
          isLoading={this.props.isLoading}
        />
        <ScrollTop />
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUsers);
